import React from "react";
import { FiLoader, FiRefreshCw, FiAward } from "react-icons/fi";
import { IoMdRefresh, IoMdRocket } from "react-icons/io";
import { MdOutlineRefresh } from "react-icons/md";

export default function Loader(props) {
  let { loading, message = "Loading...", fullScreen = true } = props;

  if (!loading) return null;

  return (
    <>
      <div className="fixed inset-0 w-full h-screen flex flex-col justify-center items-center bg-white/80 backdrop-blur-sm z-50 transition-all duration-300">
        {/* Spinner Container */}
        <div className="relative flex flex-col items-center justify-center p-6">
          {/* Main Spinner */}
          <div className="relative w-16 h-16 md:w-20 md:h-20">
            {/* Outer Ring */}
            <div className="absolute inset-0 rounded-full border-4 border-[#855DF6]/10"></div>
            
            {/* Animated Spinner */}
            <div className="absolute inset-0 rounded-full border-4 border-t-[#855DF6] border-r-[#715EFE] border-b-[#855DF6]/30 border-l-[#715EFE]/30 animate-spin"></div>
            
            {/* Inner Gradient Ring */}
            <div className="absolute inset-[6px] rounded-full bg-gradient-to-br from-[#855DF6]/5 to-[#715EFE]/5"></div>
            
            {/* Center Icon */}
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-gradient-to-br from-[#855DF6] to-[#715EFE] flex items-center justify-center shadow-lg shadow-[#715EFE]/25">
                <IoMdRocket className="w-4 h-4 md:w-5 md:h-5 text-white animate-bounce" />
              </div>
            </div>
          </div>

          {/* Loading Text */}
          <div className="mt-6 text-center">
            <p className="text-sm md:text-base font-semibold text-gray-700 animate-pulse">
              {message}
            </p>
            <div className="flex items-center justify-center gap-1.5 mt-2">
              <div className="w-1.5 h-1.5 rounded-full bg-[#855DF6] animate-bounce" style={{ animationDelay: '0ms' }}></div>
              <div className="w-1.5 h-1.5 rounded-full bg-[#715EFE] animate-bounce" style={{ animationDelay: '150ms' }}></div>
              <div className="w-1.5 h-1.5 rounded-full bg-[#855DF6] animate-bounce" style={{ animationDelay: '300ms' }}></div>
            </div>
          </div>

          {/* Optional: Brand Logo */}
          <div className="absolute bottom-8 left-1/2 -translate-x-1/2 opacity-20">
            <FiAward className="w-8 h-8 md:w-10 md:h-10 text-[#855DF6]" />
          </div>
        </div>
      </div>

      {/* Styles for custom animations */}
      <style jsx>{`
        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
        @keyframes bounce {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-8px);
          }
        }
        .animate-spin {
          animation: spin 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
        }
        .animate-bounce {
          animation: bounce 1s ease-in-out infinite;
        }
        .animate-pulse {
          animation: pulse 2s ease-in-out infinite;
        }
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
    </>
  );
}